module.exports = __webpack_public_path__ + "img/pin-ble@3x.e930aca9.png";